import $ from 'jquery';
import axios from 'axios';
// import 'slick-carousel';
import { getDOMVehicleCard } from '../../utilities';

if ($('.blog-featured').length) {
  const $currentSlide = $('.dsp-featured').find('.featured-slider-current-item');

  function initSlider($slider, initial = 4) {
    $slider.on('init beforeChange', function (event, slick) {
      if (slick.$dots) {
        const dots = slick.$dots.find('li');
        const theme = $('.slide-m-dots-featured-slider').data('theme');
        if (theme) {
          dots.addClass(theme);
        }
      }
    });
  }

  const url = new URL(window.location.origin + '/inventory/search');

  axios.get(url).then((res) => {
    let data = res.data.items.slice(0, 4);
    const lang = $('.site').data('localized-lang');

    if (data.length > 0) {
      const $featuredSlider = $('.featured-slider');
      const disclaimer = $featuredSlider.data('disclaimer');
      const initial = $featuredSlider.data('initial');
      console.log(initial);

      data.forEach((model) => {
        let $card = getDOMVehicleCard(model, disclaimer, [], lang);
        $featuredSlider.append($card);
      });

      const $loader = $(`.featured-scene`);
      $loader.hide();

      initSlider($featuredSlider, initial);

      if ($currentSlide) {
        $currentSlide.text('1/' + data.length);
      }

      $featuredSlider.addClass('opacity-100');
      $featuredSlider.removeClass('opacity-0');

      setTimeout(function () {
        $featuredSlider.find('.featured-card').removeClass('opacity-0');
        $featuredSlider.find('.featured-image').removeClass('opacity-0');
      }, 1000);
    } else {
      // remove the dom elements for the category (not needed)
      $('.featured-scene').hide();
    }
  });
} // end of if
